import ToolGroup from '~/components/toolbar/shared/ToolGroup';
import BoxZoomTool from '~/components/toolbar/tools/BoxZoomTool';
import DvhTool from '~/components/toolbar/tools/DvhTool';
import IntensityTool from '~/components/toolbar/tools/IntensityTool';
import IsolateTool from '~/components/toolbar/tools/IsolateTool';
import MeasurementTool from '~/components/toolbar/tools/MeasurementTool';
import WindowingHistogramTool from '~/components/toolbar/tools/WindowingHistogramTool';
import SeriesOverviewTool from '~/components/toolbar/tools/SeriesOverviewTool';
import PanTool from '~/components/toolbar/tools/PanTool';
import ResetViewTool from '~/components/toolbar/tools/ResetViewTool';
import RotateViewTool from '~/components/toolbar/tools/RotateViewTool';
import ScreenshotTool from '~/components/toolbar/tools/ScreenshotTool';

export default function DoseTools() {
    return (
        <>
            <ToolGroup>
                <PanTool />
                <BoxZoomTool />
                <RotateViewTool />
                <ResetViewTool />
                <WindowingHistogramTool />
                <SeriesOverviewTool />
                <MeasurementTool />
                <IntensityTool allowCircle={false} />
                <IsolateTool />
                <ScreenshotTool />
            </ToolGroup>
            <ToolGroup>
                <DvhTool />
            </ToolGroup>
        </>
    );
}
